import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import { setCurrentUnit, setPopupState } from '../../model/configuratorSlice';
import { PopupState } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const UnitSelector = () => {
    const { user, currentUnit } = useSelector(state => state.configurator);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const dispatch = useDispatch();
    const confirmUnitSelectionHandler = () => {
        dispatch(setCurrentUnit(selectedUnit));
        dispatch(setPopupState(PopupState.None));
    };

    const unitSelectedHandler = (unitSelected) => {
        if (selectedUnit !== null && selectedUnit.id === unitSelected.id) {
            setSelectedUnit(null);
        } else {
            setSelectedUnit(unitSelected);
        }
    };

    const closePopupHandler = () => {
        dispatch(setPopupState(PopupState.None));
    };

    const isUnitSelectorOpened = true;

    return (
      <div className={`unit-selector-popup ${isUnitSelectorOpened ? ' opened' : ''}`}>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={`background ${isUnitSelectorOpened ? 'opened' : ''}`}
          type="button"
        />
        <div className={`background${isUnitSelectorOpened ? ' opened' : ''}`} />
        <div className={`panel${isUnitSelectorOpened ? ' opened' : ''}`}>
          <div className="header">
            {TranslationUtility.GetFormattedMessageForUI('ui-unit-selector-panel-title', 'Selector de vivienda')}

          </div>
          <div className="sub-header">
            {TranslationUtility.GetFormattedMessageForUI('ui-unit-selector-subtitle-1',
                  'Tienes varias viviendas asignadas para esta promoción.')}

          </div>
          <div className="title">
            {TranslationUtility.GetFormattedMessageForUI('ui-unit-selector-subtitle-2',
                  'Selecciona una para continuar:')}
          </div>
          <div className="list-selector">
            {user.units.map((unit, index) => (
              <div className="unit-container">
                <button
                  onClick={() => unitSelectedHandler(unit)}
                  type="button"
                  className={`unit-button${selectedUnit !== null && selectedUnit.id === unit.id ? ' selected' : ''}`}
                >
                  <span>{unit.name}</span>
                </button>
              </div>
                    ))}

          </div>
          {!IsNullOrUndefined(currentUnit) ? (
            <button
              className="close-button"
              onClick={() => closePopupHandler()}
              type="button"
            ><CloseButton className="close-default" /><CloseButtonRollover className="close-over" />
            </button>
                ) : null}
          <button
            className="unit-selection-button"
            type="button"
            onClick={() => confirmUnitSelectionHandler()}
            disabled={IsNullOrUndefined(selectedUnit)}
          >
            <span>
              {TranslationUtility.GetFormattedMessageForUI('ui-unit-selector-button', 'Seleccionar')}
            </span>
          </button>
        </div>
      </div>
    );
};

export default UnitSelector;
